import { alertDialog } from "@sitebuilder/razor/dialog.js";

export function sendRequest({ method = "GET", url, data = null, success, error }) {
  const xhttp = new XMLHttpRequest();
  xhttp.open(method, url, true);

  const isFormData = data instanceof FormData;

  if (data && !isFormData) {
    xhttp.setRequestHeader("Content-Type", "application/json");
  }

  xhttp.onreadystatechange = () => {
    if (xhttp.readyState !== 4) return;

    const isJsonResponse = xhttp.getResponseHeader("Content-Type")?.includes("application/json");
    let response = xhttp.responseText;

    if (isJsonResponse) {
      try {
        response = JSON.parse(response);
      } catch {
        // Leave as text
      }
    }

    if (xhttp.status >= 200 && xhttp.status < 300) {
      success?.(response);
    } else {
      const err = isJsonResponse && typeof response === "object" ? response : { message: response };
      error?.(err);

      alertDialog(
        "Une erreur s'est produite",
        `Une erreur s'est produite durant l'opération :<br/><br/><strong>${Object.values(err?.errors ?? {}).join(", ") || err.message}</strong>`
      );
    }
  };

  if (method === "GET" || method === "HEAD" || data == null) {
    xhttp.send();
  } else if (isFormData) {
    xhttp.send(data); // Let browser set proper multipart/form-data boundary
  } else {
    xhttp.send(JSON.stringify(data));
  }
}

window.sendRequest = sendRequest;
 
